import React from 'react';
import ReactDOM from 'react-dom/client';
import { ClerkProvider } from '@clerk/react';
import { ErrorBoundary } from 'react-error-boundary';
import './index.css';
import App from './App';

function ErrorFallback({ error, resetErrorBoundary }: { error: Error; resetErrorBoundary: () => void }) {
  return (
    <div style={{ padding: 40, textAlign: 'center' }}>
      <h2>Something went wrong.</h2>
      {process.env.NODE_ENV === 'development' && (
        <pre style={{ color: 'red', marginBottom: 16 }}>{error.message}</pre>
      )}
      <button onClick={resetErrorBoundary}>Try again</button>
    </div>
  );
}

const clerkPublishableKey = process.env.REACT_APP_CLERK_PUBLISHABLE_KEY;

if (!clerkPublishableKey) {
  throw new Error('REACT_APP_CLERK_PUBLISHABLE_KEY is not set');
}

const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <ClerkProvider publishableKey={clerkPublishableKey}>
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <App />
      </ErrorBoundary>
    </ClerkProvider>
  </React.StrictMode>
);
